import { defineComponent, computed, resolveComponent, createElementBlock, openBlock, createBlock, createVNode, unref, createElementVNode, createTextVNode, toDisplayString, mergeProps, ref, watch, Fragment, renderList, createCommentVNode, normalizeClass, nextTick, withCtx, reactive, normalizeProps, guardReactiveProps, normalizeStyle, renderSlot } from "vue";
import { buildParameterValue, ParameterDict, Blob, ParameterList as ParameterList$1, Label, Size2D } from "@robovision/data";
import { ValidationBuilder } from "@robovision/rvai-base";
import useVuelidate from "@vuelidate/core";
import { useI18n } from "vue-i18n";
import { QItemSection, QIcon } from "quasar";
const defaultOptions = () => ({
  extraComponents: []
});
let globalOptions = defaultOptions();
function provideOptions(options = defaultOptions()) {
  globalOptions = options;
}
function useOptions() {
  return globalOptions;
}
const _hoisted_1$7 = { key: 0 };
const _hoisted_2$1 = {
  key: 0,
  class: "text-body3 multiline"
};
const _hoisted_3 = {
  key: 1,
  class: "column"
};
const _hoisted_4 = { class: "row no-wrap items-baseline q-pr-xs" };
const _hoisted_5 = { class: "text-subtitle3 multiline" };
const _hoisted_6 = {
  key: 2,
  class: "row no-wrap items-baseline"
};
const _hoisted_7 = { class: "row no-wrap items-baseline" };
const _hoisted_8 = { class: "single-line text-subtitle3 q-pl-xs" };
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "ReadOnlyParam",
  props: {
    name: {
      required: true,
      type: String
    },
    value: {
      default: void 0,
      type: [Number, String, Boolean]
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const { t: $t } = useI18n();
    const multiline = computed(() => typeof props.value === "string" && props.value.includes("\n"));
    return (_ctx, _cache) => {
      var _a, _b;
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      return __props.valueOnly ? (openBlock(), createElementBlock("div", _hoisted_1$7, [
        multiline.value ? (openBlock(), createElementBlock("div", _hoisted_2$1, [
          createVNode(_component_rv_ellipsis_text, {
            text: ((_a = __props.value) == null ? void 0 : _a.toString()) ?? unref($t)("rvai-params.general.none")
          }, null, 8, ["text"])
        ])) : (openBlock(), createBlock(_component_rv_ellipsis_text, {
          key: 1,
          class: "text-body3",
          text: ((_b = __props.value) == null ? void 0 : _b.toString()) ?? unref($t)("rvai-params.general.none")
        }, null, 8, ["text"]))
      ])) : multiline.value ? (openBlock(), createElementBlock("div", _hoisted_3, [
        createElementVNode("div", _hoisted_4, [
          createVNode(_component_rv_ellipsis_text, {
            class: "text-body3",
            text: __props.name
          }, null, 8, ["text"]),
          createTextVNode(" " + toDisplayString(unref($t)("rvai-params.general.symbols.colon")), 1)
        ]),
        createElementVNode("div", _hoisted_5, toDisplayString(__props.value ?? unref($t)("rvai-params.general.none")), 1)
      ])) : (openBlock(), createElementBlock("div", _hoisted_6, [
        createVNode(_component_rv_ellipsis_text, {
          class: "text-body3",
          text: __props.name
        }, null, 8, ["text"]),
        createElementVNode("div", _hoisted_7, [
          createTextVNode(toDisplayString(unref($t)("rvai-params.general.symbols.colon")) + " ", 1),
          createElementVNode("span", _hoisted_8, toDisplayString(__props.value ?? unref($t)("rvai-params.general.none")), 1)
        ])
      ]));
    };
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const ReadOnlyParam = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["__scopeId", "data-v-932d28a2"]]);
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "BooleanParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Boolean
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const i18nInstance = useI18n();
    const emit = __emit;
    const value = computed({
      get() {
        return props.modelValue;
      },
      set(value2) {
        const updated = value2 != null ? buildParameterValue("Boolean", value2) : void 0;
        emit("update:modelValue", updated);
      }
    });
    const valueLabel = computed(() => {
      switch (value.value) {
        case true:
          return i18nInstance.t("rvai-params.general.yes");
        case false:
          return i18nInstance.t("rvai-params.general.no");
        default:
          return i18nInstance.t("rvai-params.general.unset");
      }
    });
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).rules
    }));
    const state = computed(() => ({
      value: value.value
    }));
    useVuelidate(rules, state, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_toggle = resolveComponent("rv-toggle");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_toggle, {
        key: 0,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
        class: "q-py-sm",
        disable: __props.disable,
        "info-text": __props.definition.description ?? void 0,
        label: __props.definition.name
      }, null, 8, ["modelValue", "disable", "info-text", "label"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: valueLabel.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "DictBoolParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const i18nInstance = useI18n();
    const { t: $t } = i18nInstance;
    const emit = __emit;
    const allSelected = computed(() => {
      var _a;
      return [...((_a = props.modelValue) == null ? void 0 : _a.values()) ?? []].every((e) => e.value);
    });
    const hasSelected = computed(() => {
      var _a;
      return [...((_a = props.modelValue) == null ? void 0 : _a.values()) ?? []].some((e) => e.value);
    });
    const options = computed(() => {
      var _a;
      return ((_a = props.definition.keys) == null ? void 0 : _a.enum) || [];
    });
    const selected = computed({
      get() {
        var _a;
        return [...((_a = props.modelValue) == null ? void 0 : _a.entries()) ?? []].filter(([, { value: value2 }]) => value2).map(([key]) => key);
      },
      set(value2) {
        const items = options.value.map((opt) => [opt, value2.includes(opt)]);
        const updatedValue = ParameterDict.new().addItems(items).build();
        emit("update:modelValue", updatedValue);
      }
    });
    const value = computed(() => {
      var _a;
      if (!hasSelected.value) return void 0;
      if (allSelected.value) return $t("rvai-params.general.allSelected");
      return [...((_a = props.modelValue) == null ? void 0 : _a.entries()) ?? []].filter(([, { value: value2 }]) => value2).map(([key]) => key).join("\n");
    });
    const rules = computed(() => ({
      selected: ValidationBuilder.withLabel(props.definition.name, i18nInstance).rules
    }));
    const v$ = useVuelidate(rules, { selected: selected.value }, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_multiple_select, {
        key: 0,
        modelValue: selected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selected.value = $event),
        "all-selected-text": unref($t)("rvai-params.general.allSelected"),
        class: "dict-param full-width",
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        options: options.value,
        validation: unref(v$).selected,
        "with-chips": ""
      }, null, 8, ["modelValue", "all-selected-text", "disable", "info-text", "label", "options", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto === "undefined" || !crypto.getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = { randomUUID };
function v4(options, buf, offset) {
  var _a;
  if (native.randomUUID && true && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random ?? ((_a = options.rng) == null ? void 0 : _a.call(options)) ?? rng();
  if (rnds.length < 16) {
    throw new Error("Random bytes length must be >= 16");
  }
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return unsafeStringify(rnds);
}
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "DictKeyValueParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const { t: $t } = i18nInstance;
    function getDefaultValue() {
      var _a;
      const emptyValue = {
        id: v4(),
        row: ["", ""]
      };
      const entries = [...((_a = props.modelValue) == null ? void 0 : _a.entries()) ?? []];
      if (entries.length > 0) {
        return entries.map(([key, node]) => ({
          id: node.id,
          row: [key, node.value]
        }));
      }
      return [emptyValue];
    }
    const rows = ref(getDefaultValue());
    function removeRow(rowIndex) {
      rows.value = rows.value.filter((_, i) => i !== rowIndex);
      updateValue();
    }
    function setDictValue(value2, rowIndex) {
      const id = rows.value[rowIndex] ? rows.value[rowIndex].id : v4();
      rows.value[rowIndex] = {
        id,
        row: value2
      };
      updateValue();
    }
    async function updateValue() {
      const updatedValue = ParameterDict.new().addItems(rows.value.filter(({ row }) => {
        const [key, value2] = row;
        return !!key || !!value2;
      }).map(({ row }) => row)).build();
      emit("update:modelValue", updatedValue);
      await nextTick();
      v$.value.$validate();
    }
    const value = computed(() => {
      var _a;
      const entries = [...((_a = props.modelValue) == null ? void 0 : _a.entries()) ?? []];
      if (!entries.length || entries.every(([key]) => !key)) return void 0;
      return entries.map(([key, { value: value2 }]) => `${key}: ${value2}`).join("\n");
    });
    const rules = computed(() => rows.value.reduce((acc, {
      id,
      row: [key, value2]
    }) => {
      var _a, _b, _c, _d, _e;
      return {
        ...acc,
        [`${id}-key`]: ValidationBuilder.withLabel(props.definition.name, i18nInstance).custom(
          (key2) => {
            const equalKeysCount = rows.value.filter(({ row }) => {
              return row[0] === key2;
            }).length;
            return equalKeysCount < 2;
          },
          "rvai-params.errors.duplicatedKeys",
          [],
          "duplicatedKeys"
        ).custom(
          (key2) => {
            if (value2) return !!key2.trim();
            return true;
          },
          "rvai-params.errors.bothAreRequired",
          [],
          "requiredIf"
        ).custom(
          (key2) => {
            if (rows.value.length > 1) return !!key2.trim();
            return true;
          },
          "rvai-params.errors.bothAreRequired",
          [],
          "requiredIfHasOtherKeyValue"
        ).maxLength((_a = props.definition.keys) == null ? void 0 : _a.maxLength).minLength((_b = props.definition.keys) == null ? void 0 : _b.minLength).oneOfRegexes(((_d = (_c = props.definition.keys) == null ? void 0 : _c.pattern) == null ? void 0 : _d.map((p) => new RegExp(p))) ?? []).rules,
        [`${id}-value`]: ValidationBuilder.withLabel(props.definition.name, i18nInstance).custom(
          (value3) => {
            if (key && !props.definition.values.optional) return !!value3.trim();
            return true;
          },
          "rvai-params.errors.bothAreRequired",
          [],
          "requiredIf"
        ).maxLength("maxLength" in props.definition.values ? props.definition.values.maxLength : null).minLength("minLength" in props.definition.values ? props.definition.values.minLength : null).oneOfRegexes(
          "pattern" in props.definition.values ? ((_e = props.definition.values.pattern) == null ? void 0 : _e.map((p) => new RegExp(p))) ?? [] : []
        ).rules
      };
    }, {}));
    const dataForValidation = computed(() => rows.value.reduce((acc, {
      id,
      row: [key, value2]
    }) => ({
      ...acc,
      [`${id}-key`]: key,
      [`${id}-value`]: value2
    }), {}));
    const v$ = useVuelidate(rules, dataForValidation, { $autoDirty: true });
    watch(() => props.modelValue, (curr, prev) => {
      const previousEntries = [...(prev == null ? void 0 : prev.entries()) ?? []];
      if (!previousEntries.length) return;
      const currentEntries = [...(curr == null ? void 0 : curr.entries()) ?? []];
      if (!currentEntries.length) {
        rows.value = getDefaultValue();
        updateValue();
      }
    });
    return (_ctx, _cache) => {
      const _component_rv_combined_inputs = resolveComponent("rv-combined-inputs");
      const _component_rv_button = resolveComponent("rv-button");
      return !__props.readonly ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(rows.value, (v, i) => {
        return openBlock(), createElementBlock("div", {
          key: v.id,
          class: "dict-key-value-param row full-width no-wrap justify-between items-start"
        }, [
          createVNode(_component_rv_combined_inputs, {
            class: normalizeClass(["dict-key-value-param__row", {
              "q-mb-md": rows.value.length - 1 !== i
            }]),
            "data-automation": "dict-key-value-param__row",
            disable: __props.disable,
            hint: "",
            "info-text": __props.definition.description,
            label: i ? "" : __props.definition.name,
            "model-value": v.row,
            placeholders: [unref($t)("rvai-params.general.key"), unref($t)("rvai-params.general.value")],
            readonly: __props.readonly,
            separator: ":",
            "show-optional-label": __props.definition.optional,
            validation: [unref(v$)[`${v.id}-key`], unref(v$)[`${v.id}-value`]],
            "onUpdate:modelValue": ($event) => setDictValue($event, i)
          }, null, 8, ["class", "disable", "info-text", "label", "model-value", "placeholders", "readonly", "show-optional-label", "validation", "onUpdate:modelValue"]),
          !__props.readonly ? (openBlock(), createBlock(_component_rv_button, {
            key: 0,
            class: normalizeClass(["dict-key-value-param__btn q-ml-sm", {
              "dict-key-value-param__btn--first-row": !i
            }]),
            "data-automation": "dict-key-value-param__add",
            disable: !v.row[0].length || !v.row[1].length || !!rows.value[i + 1],
            icon: "mdi-plus",
            size: "sm",
            tertiary: "",
            onClick: ($event) => setDictValue(["", ""], i + 1)
          }, null, 8, ["class", "disable", "onClick"])) : createCommentVNode("", true),
          !__props.readonly ? (openBlock(), createBlock(_component_rv_button, {
            key: 1,
            class: normalizeClass(["dict-key-value-param__btn q-ml-sm", {
              "dict-key-value-param__btn--first-row": !i
            }]),
            "data-automation": "dict-key-value-param__remove",
            disable: rows.value.length === 1,
            icon: "mdi-delete",
            size: "sm",
            tertiary: "",
            onClick: ($event) => removeRow(i)
          }, null, 8, ["class", "disable", "onClick"])) : createCommentVNode("", true)
        ]);
      }), 128)) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const DictKeyValueParam = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["__scopeId", "data-v-a5b1acd6"]]);
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "EnumParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const value = computed({
      get() {
        return props.modelValue;
      },
      set(value2) {
        const updated = value2 != null ? buildParameterValue("Text", value2) : value2;
        emit("update:modelValue", updated);
      }
    });
    const i18nInstance = useI18n();
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).rules
    }));
    const state = computed(() => ({
      value: value.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_select = resolveComponent("rv-select");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_select, {
        key: 0,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        options: __props.definition.enum ?? [],
        readonly: __props.readonly,
        "show-optional-label": __props.definition.optional,
        validation: unref(v$).value
      }, null, 8, ["modelValue", "disable", "info-text", "label", "options", "readonly", "show-optional-label", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$6 = {
  key: 0,
  class: "file-param"
};
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "FileParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const file = ref([]);
    const value = computed(() => file.value && file.value.length ? file.value[0].name : void 0);
    async function updateValue(value2) {
      file.value = value2;
      if (value2 && value2.length) {
        emit("update:modelValue", await Blob.fromFile(value2[0]));
      } else {
        clearAll();
      }
    }
    function clearAll() {
      emit("update:modelValue", void 0);
    }
    return (_ctx, _cache) => {
      const _component_rv_dropzone = resolveComponent("rv-dropzone");
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$6, [
        createVNode(_component_rv_dropzone, {
          "allowed-extensions": props.definition.extension,
          disable: __props.disable,
          "max-files": 1,
          "model-value": __props.modelValue,
          multiple: false,
          onClear: clearAll,
          "onUpdate:modelValue": updateValue
        }, null, 8, ["allowed-extensions", "disable", "model-value"])
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$5 = {
  key: 0,
  class: "row no-wrap items-end"
};
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "FloatParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Object, Number]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    var _a;
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const isSlider = computed(() => props.definition.widget === "slider" && props.definition.maximum != null && props.definition.minimum != null);
    const valueRef = ref(typeof props.modelValue === "number" ? props.modelValue : (_a = props.modelValue) == null ? void 0 : _a.value);
    const isPercentage = computed(() => props.definition.widget === "percentage");
    const value = computed({
      get() {
        return isPercentage.value && valueRef.value ? valueRef.value * 100 : valueRef.value;
      },
      set(value2) {
        valueRef.value = isPercentage.value && value2 ? value2 / 100 : value2;
        if (valueRef.value == null) {
          emit("update:modelValue", void 0);
        } else {
          const parsed = Number(valueRef.value);
          if (!isNaN(parsed)) {
            const updated = buildParameterValue("Float", parsed);
            emit("update:modelValue", updated);
          }
        }
      }
    });
    const maxValue = computed(() => props.definition.exclusiveMaximum ?? props.definition.maximum);
    const hasMaxValue = computed(() => maxValue.value != null);
    const maxValueExclusive = computed(() => props.definition.exclusiveMaximum != null);
    const minValue = computed(() => props.definition.minimum ?? props.definition.exclusiveMinimum);
    const hasMinValue = computed(() => minValue.value != null);
    const minValueExclusive = computed(() => props.definition.exclusiveMinimum != null);
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.decimal.minValueIf(hasMinValue.value, minValue.value, !minValueExclusive.value).maxValueIf(hasMaxValue.value, maxValue.value, !maxValueExclusive.value).rules
    }));
    const state = computed(() => ({
      value: valueRef.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    watch(
      () => props.modelValue,
      () => {
        var _a2;
        const newValue = typeof props.modelValue === "number" ? props.modelValue : (_a2 = props.modelValue) == null ? void 0 : _a2.value;
        if (Number(valueRef.value) !== Number(newValue)) {
          valueRef.value = newValue;
        }
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_slider = resolveComponent("rv-slider");
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$5, [
        isSlider.value ? (openBlock(), createBlock(_component_rv_slider, {
          key: 0,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
          class: "full-width",
          disable: __props.disable,
          float: "",
          "info-text": __props.definition.description,
          "input-decimals": 3,
          label: __props.definition.name,
          max: __props.definition.maximum,
          min: __props.definition.minimum,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          step: 0.1,
          suffix: isPercentage.value ? "%" : void 0,
          validation: unref(v$).value,
          "with-input": ""
        }, null, 8, ["modelValue", "disable", "info-text", "label", "max", "min", "readonly", "show-optional-label", "suffix", "validation"])) : (openBlock(), createBlock(_component_rv_input, {
          key: 1,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => value.value = $event),
          class: "full-width",
          disable: __props.disable,
          "info-text": __props.definition.description,
          label: __props.definition.name,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          suffix: isPercentage.value ? "%" : void 0,
          validation: unref(v$).value
        }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "suffix", "validation"]))
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "FloatRangeParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Object]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const defaultValues = computed(() => Object.assign({
      lowerBound: 0.3,
      lowerInclusive: false,
      upperBound: 0.5,
      upperInclusive: false
    }, props.definition.default));
    const valueRef = ref(getRangeValue(props.modelValue));
    const value = computed({
      get() {
        return valueRef.value;
      },
      set(value2) {
        var _a, _b;
        valueRef.value = value2;
        emit(
          "update:modelValue",
          buildParameterValue("FloatRange", {
            lowerBound: valueRef.value.min,
            lowerInclusive: ((_a = props.modelValue) == null ? void 0 : _a.lowerInclusive) ?? defaultValues.value.lowerInclusive,
            upperBound: valueRef.value.max,
            upperInclusive: ((_b = props.modelValue) == null ? void 0 : _b.upperInclusive) ?? defaultValues.value.upperInclusive
          })
        );
      }
    });
    const maxValue = computed(() => props.definition.exclusiveMaximum ?? props.definition.maximum);
    const hasMaxValue = computed(() => maxValue.value != null);
    const maxValueExclusive = computed(() => props.definition.exclusiveMaximum != null);
    const minValue = computed(() => props.definition.minimum ?? props.definition.exclusiveMinimum);
    const hasMinValue = computed(() => minValue.value != null);
    const minValueExclusive = computed(() => props.definition.exclusiveMinimum != null);
    const rules = computed(() => ({
      max: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.decimal.maxValueIf(hasMaxValue.value, maxValue.value, !maxValueExclusive.value).rules,
      min: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.decimal.minValueIf(hasMinValue.value, minValue.value, !minValueExclusive.value).rules
    }));
    const state = computed(() => ({
      max: valueRef.value.max,
      min: valueRef.value.min
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    function getRangeValue(value2) {
      return {
        max: (value2 == null ? void 0 : value2.upperBound) ?? defaultValues.value.upperBound,
        min: (value2 == null ? void 0 : value2.lowerBound) ?? defaultValues.value.lowerBound
      };
    }
    watch(
      () => props.modelValue,
      (newValue) => {
        valueRef.value = getRangeValue(newValue);
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_range = resolveComponent("rv-range");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_range, {
        key: 0,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
        class: "full-width",
        disable: __props.disable,
        "info-text": __props.definition.description ?? void 0,
        "input-decimals": 3,
        label: __props.definition.name,
        max: __props.definition.maximum ?? void 0,
        min: __props.definition.minimum ?? void 0,
        "show-optional-label": __props.definition.optional,
        step: 0.1,
        validation: unref(v$).value,
        "with-input": ""
      }, null, 8, ["modelValue", "disable", "info-text", "label", "max", "min", "show-optional-label", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: props.modelValue ? `${props.modelValue.lowerBound} - ${props.modelValue.upperBound}` : void 0,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$4 = {
  key: 0,
  class: "text-small text-grey-1 q-pt-md"
};
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "GroupParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const expanded = ref(false);
    function onUpdateParam(key, value) {
      emit("update:modelValue", {
        ...props.modelValue && props.modelValue,
        [key]: value
      });
    }
    return (_ctx, _cache) => {
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      const _component_rv_parameter = resolveComponent("rv-parameter");
      const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
      return openBlock(), createBlock(_component_rv_expansion_item, {
        modelValue: expanded.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => expanded.value = $event),
        class: "rv-group-param",
        dense: "",
        "switch-toggle-side": ""
      }, {
        header: withCtx(() => [
          createVNode(unref(QItemSection), null, {
            default: withCtx(() => [
              createVNode(_component_rv_ellipsis_text, {
                class: "text-subtitle3",
                disable: __props.disable,
                text: __props.definition.name
              }, null, 8, ["disable", "text"])
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          __props.definition.description ? (openBlock(), createElementBlock("div", _hoisted_1$4, toDisplayString(__props.definition.description), 1)) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.definition.fields, (param, key) => {
            return openBlock(), createBlock(_component_rv_parameter, {
              key,
              class: "q-my-md q-mx-sm",
              definition: param,
              disable: __props.disable,
              "model-value": __props.modelValue ? __props.modelValue[key] : void 0,
              readonly: __props.readonly,
              "value-only": __props.valueOnly,
              "onUpdate:modelValue": ($event) => onUpdateParam(key, $event)
            }, null, 8, ["definition", "disable", "model-value", "readonly", "value-only", "onUpdate:modelValue"]);
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
const _hoisted_1$3 = {
  key: 0,
  class: "row no-wrap items-end"
};
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "IntegerParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Object, Number]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    var _a;
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const valueRef = ref(typeof props.modelValue === "number" ? props.modelValue : (_a = props.modelValue) == null ? void 0 : _a.value);
    const value = computed({
      get() {
        return valueRef.value;
      },
      set(value2) {
        valueRef.value = value2;
        if (value2 == null) {
          emit("update:modelValue", void 0);
        } else {
          const parsed = Number(value2);
          if (!isNaN(parsed)) {
            const updated = buildParameterValue("Integer", parsed);
            emit("update:modelValue", updated);
          }
        }
      }
    });
    const isSlider = computed(() => props.definition.widget === "slider" && props.definition.maximum != null && props.definition.minimum != null);
    const maxValue = computed(() => props.definition.exclusiveMaximum ?? props.definition.maximum);
    const hasMaxValue = computed(() => maxValue.value != null);
    const maxValueExclusive = computed(() => props.definition.exclusiveMaximum != null);
    const minValue = computed(() => props.definition.minimum ?? props.definition.exclusiveMinimum);
    const hasMinValue = computed(() => minValue.value != null);
    const minValueExclusive = computed(() => props.definition.exclusiveMinimum != null);
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.integer.minValueIf(hasMinValue.value, minValue.value, !minValueExclusive.value).maxValueIf(hasMaxValue.value, maxValue.value, !maxValueExclusive.value).rules
    }));
    const state = computed(() => ({
      value: value.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    watch(
      () => props.modelValue,
      () => {
        var _a2;
        const newValue = typeof props.modelValue === "number" ? props.modelValue : (_a2 = props.modelValue) == null ? void 0 : _a2.value;
        if (Number(valueRef.value) !== Number(newValue)) {
          valueRef.value = newValue;
        }
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_slider = resolveComponent("rv-slider");
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$3, [
        isSlider.value ? (openBlock(), createBlock(_component_rv_slider, {
          key: 0,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
          class: "full-width",
          disable: __props.disable,
          "info-text": __props.definition.description,
          label: __props.definition.name,
          max: __props.definition.maximum,
          min: __props.definition.minimum,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          validation: unref(v$).value,
          "with-input": ""
        }, null, 8, ["modelValue", "disable", "info-text", "label", "max", "min", "readonly", "show-optional-label", "validation"])) : (openBlock(), createBlock(_component_rv_input, {
          key: 1,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => value.value = $event),
          class: "full-width",
          disable: __props.disable,
          "info-text": __props.definition.description,
          label: __props.definition.name,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          validation: unref(v$).value
        }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "validation"]))
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$2 = { key: 1 };
const _hoisted_2 = { class: "no-wrap flex-inline max-width-full" };
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "ListParam",
  props: {
    dataDependencies: {
      default: void 0,
      type: Object
    },
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const i18nInstance = useI18n();
    const { t: $t } = i18nInstance;
    const emit = __emit;
    const classes = computed(() => {
      var _a;
      return ((_a = props.dataDependencies) == null ? void 0 : _a.classes) ?? [];
    });
    const options = computed(() => {
      return classes.value.map((c) => ({
        color: c.color,
        label: c.name,
        value: c.id
      }));
    });
    const selectedRef = ref(getSelectedOptionsValue(props.modelValue));
    const selected = computed({
      get() {
        return selectedRef.value;
      },
      set(value) {
        selectedRef.value = value;
        const updatedValue = ParameterList$1.new().addValues(value.map((o) => [o.value, new Label(o.value)])).build();
        emit("update:modelValue", updatedValue);
      }
    });
    const hasSelected = computed(() => {
      return selected.value.length > 0;
    });
    const allSelected = computed(() => {
      return classes.value.length > 0 && classes.value.every((c) => selected.value.some((s) => s.value === c.id));
    });
    const rules = computed(() => ({
      selected: ValidationBuilder.withLabel(props.definition.name, i18nInstance).custom(
        (value) => props.definition.optional || value.length > 0,
        "rvai-params.errors.selectionRequired"
      ).rules
    }));
    const state = computed(() => ({
      selected: selected.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    function getSelectOptionValue(parameterNode) {
      var _a;
      return {
        color: (_a = classes.value.find((e) => e.id === parameterNode.key)) == null ? void 0 : _a.color,
        label: parameterNode.key,
        value: parameterNode.key
      };
    }
    function getSelectedOptionsValue(value) {
      return (value ?? []).map(getSelectOptionValue);
    }
    watch(
      () => props.dataDependencies,
      () => {
        selectedRef.value = getSelectedOptionsValue(props.modelValue);
      }
    );
    watch(
      () => props.modelValue,
      (newValue) => {
        selectedRef.value = getSelectedOptionsValue(newValue);
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
      const _component_rv_bullet = resolveComponent("rv-bullet");
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_multiple_select, {
        key: 0,
        modelValue: selected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selected.value = $event),
        "all-selected-text": unref($t)("rvai-params.general.allSelected"),
        class: "full-width",
        disable: __props.disable,
        "info-text": __props.definition.description ?? void 0,
        label: __props.definition.name,
        options: options.value,
        validation: unref(v$).selected,
        "with-chips": ""
      }, null, 8, ["modelValue", "all-selected-text", "disable", "info-text", "label", "options", "validation"])) : (openBlock(), createElementBlock("div", _hoisted_1$2, [
        hasSelected.value && !allSelected.value ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(selected.value, (option) => {
          return openBlock(), createElementBlock("div", {
            key: option.value,
            class: "full-width q-pb-sm"
          }, [
            createElementVNode("div", _hoisted_2, [
              createVNode(_component_rv_bullet, {
                class: "q-pr-sm",
                color: option.color,
                "is-tooltip-shown": false,
                size: 8
              }, null, 8, ["color"]),
              createVNode(_component_rv_ellipsis_text, {
                class: "zero-min-width",
                text: option.value
              }, null, 8, ["text"])
            ])
          ]);
        }), 128)) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
          name: __props.definition.name,
          value: allSelected.value ? unref($t)("rvai-params.general.allSelected") : void 0,
          "value-only": __props.valueOnly
        }), null, 16, ["name", "value", "value-only"]))
      ]));
    };
  }
});
const ListParam = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__scopeId", "data-v-0c7b8b9d"]]);
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "Size2DParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    var _a, _b;
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const currentValue = reactive({
      height: String(((_a = props.modelValue) == null ? void 0 : _a.height) ?? ""),
      width: String(((_b = props.modelValue) == null ? void 0 : _b.width) ?? "")
    });
    const arrayValue = computed({
      get() {
        return [currentValue.width, currentValue.height];
      },
      set(value) {
        const [width, height] = value;
        Object.assign(currentValue, {
          height,
          width
        });
        emitUpdate();
      }
    });
    const readOnlyValue = computed(() => {
      if (!props.modelValue) return void 0;
      const {
        height,
        width
      } = props.modelValue;
      return `${width} x ${height}`;
    });
    watch(() => props.modelValue, (value) => {
      Object.assign(currentValue, {
        height: String((value == null ? void 0 : value.height) ?? ""),
        width: String((value == null ? void 0 : value.width) ?? "")
      });
    });
    function emitUpdate() {
      const {
        height,
        width
      } = currentValue;
      if (!height || !width) {
        return emit("update:modelValue", void 0);
      }
      const parsedHeight = Number(height);
      const parsedWidth = Number(width);
      if (parsedHeight != null && !isNaN(parsedHeight) && parsedWidth != null && !isNaN(parsedWidth)) {
        emit("update:modelValue", new Size2D(parsedHeight, parsedWidth));
      } else {
        return emit("update:modelValue", void 0);
      }
    }
    const rules = computed(() => {
      var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j;
      return {
        height: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.minValueIf(!props.definition.optional && ((_a2 = props.definition.minSize) == null ? void 0 : _a2.width) != null, (_b2 = props.definition.minSize) == null ? void 0 : _b2.width).maxValueIf(!props.definition.optional && ((_c = props.definition.maxSize) == null ? void 0 : _c.width) != null, (_d = props.definition.maxSize) == null ? void 0 : _d.width).equalTo((_e = props.definition.exactSize) == null ? void 0 : _e.width).rules,
        width: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.minValueIf(!props.definition.optional && ((_f = props.definition.minSize) == null ? void 0 : _f.width) != null, (_g = props.definition.minSize) == null ? void 0 : _g.width).maxValueIf(!props.definition.optional && ((_h = props.definition.maxSize) == null ? void 0 : _h.width) != null, (_i = props.definition.maxSize) == null ? void 0 : _i.width).equalTo((_j = props.definition.exactSize) == null ? void 0 : _j.width).rules
      };
    });
    const v$ = useVuelidate(
      rules,
      currentValue,
      { $autoDirty: true }
    );
    return (_ctx, _cache) => {
      const _component_rv_combined_inputs = resolveComponent("rv-combined-inputs");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_combined_inputs, {
        key: 0,
        modelValue: arrayValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => arrayValue.value = $event),
        class: "size2d-param full-width",
        disable: __props.disable,
        hint: "Width x height",
        "info-text": __props.definition.description,
        label: __props.definition.name,
        readonly: __props.readonly,
        separator: "x",
        validation: [unref(v$).width, unref(v$).height]
      }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: readOnlyValue.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const Size2DParam = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-deffc5d2"]]);
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "TextParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const VALID_TYPES = [
      "text",
      "password",
      "textarea",
      "time",
      "date",
      "datetime-local"
    ];
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const value = computed({
      get() {
        return props.modelValue;
      },
      set(value2) {
        const updated = value2 ? buildParameterValue("Text", value2) : null;
        emit("update:modelValue", updated);
      }
    });
    const type = computed(() => {
      const { widget } = props.definition;
      if (widget && VALID_TYPES.includes(widget)) {
        return widget;
      } else {
        return void 0;
      }
    });
    const rules = computed(() => {
      var _a, _b, _c, _d;
      return {
        value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).maxLength((_a = props.definition) == null ? void 0 : _a.maxLength).minLength((_b = props.definition) == null ? void 0 : _b.minLength).oneOfRegexes(((_d = (_c = props.definition) == null ? void 0 : _c.pattern) == null ? void 0 : _d.map((p) => new RegExp(p))) ?? []).rules
      };
    });
    const state = computed(() => ({
      value: value.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_input, {
        key: 0,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        readonly: __props.readonly,
        "show-optional-label": __props.definition.optional,
        type: type.value,
        validation: unref(v$).value
      }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "type", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$4 = defineComponent({
  components: {
    QIcon
  },
  inheritAttrs: false,
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    hideLabel: {
      default: false,
      type: Boolean
    }
  }
});
const _hoisted_1$1 = { class: "row no-wrap items-center" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
  const _component_rv_tooltip = resolveComponent("rv-tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    !_ctx.hideLabel ? (openBlock(), createBlock(_component_rv_ellipsis_text, mergeProps({ key: 0 }, _ctx.$attrs, {
      class: "text-subtitle3",
      disable: _ctx.disable,
      text: _ctx.definition.name
    }), null, 16, ["disable", "text"])) : createCommentVNode("", true),
    _ctx.definition.description ? (openBlock(), createBlock(_component_QIcon, {
      key: 1,
      class: "info-icon q-mx-xs",
      color: "dark",
      name: "info",
      size: "16px"
    }, {
      default: withCtx(() => [
        createVNode(_component_rv_tooltip, null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.definition.description), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : createCommentVNode("", true)
  ]);
}
const ParamTitle = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$1]]);
const _hoisted_1 = { key: 0 };
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "UnsupportedParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Number, Object, String, Boolean]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const value = computed(() => {
      return JSON.stringify(props.modelValue, null, 2) ?? "(Unsupported type)";
    });
    return (_ctx, _cache) => {
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(ParamTitle, {
          definition: __props.definition,
          disable: __props.disable
        }, null, 8, ["definition", "disable"]),
        createElementVNode("span", {
          class: normalizeClass(["text-body3 text-grey-1", { "disabled": __props.disable }])
        }, " Unsupported parameter type (" + toDisplayString(__props.definition.type) + ") ", 3)
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "UriParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const isWebhookUrl = computed(() => {
      const { widget } = props.definition;
      return widget === "webhook";
    });
    const url = ref(props.modelValue);
    const emit = __emit;
    function onBlur() {
      try {
        const urlObject = url.value ? buildParameterValue("URI", url.value) : void 0;
        url.value = urlObject ? urlObject.toString() : "";
        emit("update:modelValue", urlObject);
      } catch (err) {
        console.log(err);
      }
    }
    const uriRegex = /(?<scheme>.*):\/\/(?<authority>[^/]*)(?:\/(?<path>[^/?]*))?(?:\?(?<query>[^#]*))?(?:#(?<fragment>.*))?/;
    const urlRegex = /^https?:\/\/(\S+(?::\S+@))?([a-zA-Z0-9-:]+\.)*[a-zA-Z0-9-:]{2,}(\/[^\s]*)?$/;
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props.definition.name).requiredIf(!props.definition.optional).regex(isWebhookUrl.value ? urlRegex : uriRegex).rules
    }));
    const state = computed(() => ({
      value: url.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_input, {
        key: 0,
        modelValue: url.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => url.value = $event),
        "bottom-slots": "",
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        readonly: __props.readonly,
        "show-optional-label": __props.definition.optional,
        validation: unref(v$).value,
        onBlur
      }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: url.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const ComponentMap = {
  Blob: _sfc_main$c,
  Boolean: _sfc_main$g,
  // these 2 components are not implemented for the correct
  // param type. they should be revisited if they are ever needed.
  // Box2D: Box2DParam,
  // Box3D: Box3DParam,
  Float: _sfc_main$b,
  FloatRange: _sfc_main$a,
  Integer: _sfc_main$8,
  List: ListParam,
  Object: _sfc_main$9,
  Size2D: Size2DParam,
  Text: _sfc_main$5,
  URI: _sfc_main$2
};
function mapToComponent(definition, extraComponents = []) {
  var _a, _b;
  for (const entry of extraComponents) {
    if (entry.supports(definition)) {
      return entry.component;
    }
  }
  if (definition.type === "Text" && ((_a = definition.enum) == null ? void 0 : _a.length)) {
    return _sfc_main$d;
  }
  if (definition.type === "Dict" && definition.values.type === "Boolean" && ((_b = definition.keys) == null ? void 0 : _b.enum) != null) {
    return _sfc_main$f;
  }
  if (definition.type === "Dict" && definition.values.type === "Text") {
    return DictKeyValueParam;
  }
  const component = ComponentMap[definition.type];
  if (!component) {
    console.warn(`Could not find component for param ${definition.name} with type ${definition.type}`);
    return _sfc_main$3;
  }
  return component;
}
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "Parameter",
  props: {
    dataDependencies: {
      default: void 0,
      type: Object
    },
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Number, Object, String, Boolean]
    },
    /**
     * Daemon parameter requires project to be known.
     *
     * If it is not provided, the daemon parameter loads the project
     * based on the projectName route parameter.
     */
    project: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { extraComponents } = useOptions();
    const ParamComponent = mapToComponent(props.definition, extraComponents);
    function onUpdateModelValue(value, isDefaultValue) {
      emit("update:modelValue", value, isDefaultValue);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(ParamComponent), {
        "data-dependencies": __props.dataDependencies,
        definition: __props.definition,
        disable: __props.disable,
        "model-value": __props.modelValue,
        project: __props.project,
        readonly: __props.readonly,
        "value-only": __props.valueOnly,
        "onUpdate:modelValue": onUpdateModelValue
      }, null, 8, ["data-dependencies", "definition", "disable", "model-value", "project", "readonly", "value-only"]);
    };
  }
});
var HttpStatusCode;
(function(HttpStatusCode2) {
  HttpStatusCode2[HttpStatusCode2["CONTINUE"] = 100] = "CONTINUE";
  HttpStatusCode2[HttpStatusCode2["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
  HttpStatusCode2[HttpStatusCode2["PROCESSING"] = 102] = "PROCESSING";
  HttpStatusCode2[HttpStatusCode2["OK"] = 200] = "OK";
  HttpStatusCode2[HttpStatusCode2["CREATED"] = 201] = "CREATED";
  HttpStatusCode2[HttpStatusCode2["ACCEPTED"] = 202] = "ACCEPTED";
  HttpStatusCode2[HttpStatusCode2["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
  HttpStatusCode2[HttpStatusCode2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpStatusCode2[HttpStatusCode2["RESET_CONTENT"] = 205] = "RESET_CONTENT";
  HttpStatusCode2[HttpStatusCode2["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
  HttpStatusCode2[HttpStatusCode2["MULTI_STATUS"] = 207] = "MULTI_STATUS";
  HttpStatusCode2[HttpStatusCode2["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
  HttpStatusCode2[HttpStatusCode2["IM_USED"] = 226] = "IM_USED";
  HttpStatusCode2[HttpStatusCode2["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
  HttpStatusCode2[HttpStatusCode2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
  HttpStatusCode2[HttpStatusCode2["FOUND"] = 302] = "FOUND";
  HttpStatusCode2[HttpStatusCode2["SEE_OTHER"] = 303] = "SEE_OTHER";
  HttpStatusCode2[HttpStatusCode2["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
  HttpStatusCode2[HttpStatusCode2["USE_PROXY"] = 305] = "USE_PROXY";
  HttpStatusCode2[HttpStatusCode2["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
  HttpStatusCode2[HttpStatusCode2["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatusCode2[HttpStatusCode2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatusCode2[HttpStatusCode2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatusCode2[HttpStatusCode2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  HttpStatusCode2[HttpStatusCode2["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
  HttpStatusCode2[HttpStatusCode2["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatusCode2[HttpStatusCode2["GONE"] = 410] = "GONE";
  HttpStatusCode2[HttpStatusCode2["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
  HttpStatusCode2[HttpStatusCode2["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
  HttpStatusCode2[HttpStatusCode2["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
  HttpStatusCode2[HttpStatusCode2["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
  HttpStatusCode2[HttpStatusCode2["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
  HttpStatusCode2[HttpStatusCode2["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
  HttpStatusCode2[HttpStatusCode2["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatusCode2[HttpStatusCode2["LOCKED"] = 423] = "LOCKED";
  HttpStatusCode2[HttpStatusCode2["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
  HttpStatusCode2[HttpStatusCode2["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatusCode2[HttpStatusCode2["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
  HttpStatusCode2[HttpStatusCode2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatusCode2[HttpStatusCode2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
  HttpStatusCode2[HttpStatusCode2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  HttpStatusCode2[HttpStatusCode2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  HttpStatusCode2[HttpStatusCode2["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
  HttpStatusCode2[HttpStatusCode2["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
  HttpStatusCode2[HttpStatusCode2["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
  HttpStatusCode2[HttpStatusCode2["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
  HttpStatusCode2[HttpStatusCode2["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
  HttpStatusCode2[HttpStatusCode2["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpStatusCode || (HttpStatusCode = {}));
var DateTemplates;
(function(DateTemplates2) {
  DateTemplates2["Days"] = "MMMM d";
  DateTemplates2["Long"] = "yyyy-MM-dd HH:mm:ss";
  DateTemplates2["Short"] = "yyyy-MM-dd";
})(DateTemplates || (DateTemplates = {}));
({
  isMac: (() => {
    try {
      return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    } catch {
      return false;
    }
  })()
});
new Intl.Collator(void 0, {
  numeric: true,
  sensitivity: "base"
}).compare;
function groupBy(iterable, key) {
  const map = /* @__PURE__ */ new Map();
  for (const t of iterable) {
    const groupKey = t[key];
    const group = map.get(groupKey);
    if (group) {
      group.push(t);
    } else {
      map.set(groupKey, [t]);
    }
  }
  return map;
}
function isEmptyPlainObject(object) {
  return object != null && Object.keys(object).length === 0;
}
const ORDER_LAST = 9999;
const _sfc_main = defineComponent({
  name: "ParameterList",
  props: {
    advancedParamsClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    groups: {
      default: () => [],
      type: Array
    },
    fields: {
      required: true,
      type: Array
    },
    groupId: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    values: {
      default: void 0,
      type: Object
    }
  },
  setup(props) {
    const { t: $t } = useI18n();
    const expanded = ref(false);
    const groupedParams = computed(() => groupBy(props.fields, "groupId"));
    const allParams = computed(() => props.groupId ? groupedParams.value.get(props.groupId) : groupedParams.value.get(null));
    const visibleParams = computed(() => {
      var _a;
      return (_a = allParams.value) == null ? void 0 : _a.filter((p) => !isHiddenParam(p));
    });
    const params = computed(() => {
      var _a;
      return (_a = visibleParams.value) == null ? void 0 : _a.filter((p) => !isAdvanceParam(p));
    });
    const advancedParams = computed(() => {
      var _a;
      return (_a = visibleParams.value) == null ? void 0 : _a.filter(isAdvanceParam);
    });
    function getGroupOrder(group) {
      const idx = props.fields.findIndex((p) => p.groupId === group.id);
      return idx >= 0 ? idx : void 0;
    }
    function getOrder(v) {
      const idx = props.fields.indexOf(v);
      return idx >= 0 ? idx : void 0;
    }
    function isAdvanceParam(v) {
      var _a;
      return ((_a = v == null ? void 0 : v.metadata) == null ? void 0 : _a.expertise) === "advanced";
    }
    function isHiddenParam(v) {
      var _a;
      return ((_a = v == null ? void 0 : v.metadata) == null ? void 0 : _a.visibility) === "hidden";
    }
    function showGroup(group) {
      if (!group.toggles || isEmptyPlainObject(group.toggles)) return true;
      return Object.entries(group.toggles).every(([toggleKey, toggleValue]) => {
        var _a;
        const paramValue = (_a = props.values) == null ? void 0 : _a[toggleKey];
        return paramValue === toggleValue;
      });
    }
    return {
      $t,
      advancedParams,
      expanded,
      getGroupOrder,
      getOrder,
      groupedParams,
      ORDER_LAST,
      params,
      showGroup
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_ParameterList = resolveComponent("ParameterList", true);
  const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
  const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
  return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(_ctx.$attrs)), [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group) => {
      return openBlock(), createElementBlock(Fragment, {
        key: group.id
      }, [
        _ctx.showGroup(group) ? (openBlock(), createBlock(_component_rv_expansion_item, {
          key: 0,
          border: "",
          class: "q-mb-sm",
          "content-class": {
            "q-mt-sm": _ctx.readonly,
            "q-pt-md": !_ctx.readonly
          },
          "default-opened": "",
          label: group.name,
          style: normalizeStyle({ order: _ctx.getGroupOrder(group) })
        }, {
          default: withCtx(() => [
            createVNode(_component_ParameterList, mergeProps({ ref_for: true }, _ctx.$attrs, {
              fields: _ctx.fields,
              "group-id": group.id,
              groups: group.subGroups,
              readonly: _ctx.readonly,
              values: _ctx.values
            }), {
              param: withCtx(({ param: nested }) => [
                createElementVNode("div", {
                  style: normalizeStyle({ order: _ctx.getOrder(nested) })
                }, [
                  renderSlot(_ctx.$slots, "param", { param: nested })
                ], 4)
              ]),
              _: 3
            }, 16, ["fields", "group-id", "groups", "readonly", "values"])
          ]),
          _: 2
        }, 1032, ["content-class", "label", "style"])) : createCommentVNode("", true)
      ], 64);
    }), 128)),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.params, (param) => {
      return openBlock(), createElementBlock("div", {
        key: param.key,
        style: normalizeStyle({ order: _ctx.getOrder(param) })
      }, [
        renderSlot(_ctx.$slots, "param", { param })
      ], 4);
    }), 128)),
    ((_a = _ctx.advancedParams) == null ? void 0 : _a.length) ? (openBlock(), createBlock(_component_rv_expansion_item, {
      key: 0,
      modelValue: _ctx.expanded,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.expanded = $event),
      class: normalizeClass(["advanced-parameters q-pa-md border-card rounded-borders", { "q-mt-sm": _ctx.readonly }]),
      "content-class": _ctx.advancedParamsClass,
      "header-class": { "q-mb-md": _ctx.expanded && !_ctx.readonly },
      style: normalizeStyle({ order: _ctx.ORDER_LAST })
    }, {
      label: withCtx(() => [
        createVNode(_component_rv_ellipsis_text, {
          class: "zero-min-width text-subtitle3",
          text: _ctx.$t("rvai-params.general.text.advancedParams")
        }, null, 8, ["text"])
      ]),
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.advancedParams, (param) => {
          return openBlock(), createElementBlock("div", {
            key: param.key,
            style: normalizeStyle({ order: _ctx.getOrder(param) })
          }, [
            renderSlot(_ctx.$slots, "param", { param })
          ], 4);
        }), 128))
      ]),
      _: 3
    }, 8, ["modelValue", "class", "content-class", "header-class", "style"])) : createCommentVNode("", true)
  ], 16);
}
const ParameterList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
const components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ParamTitle,
  Parameter: _sfc_main$1,
  ParameterList,
  ReadOnlyParam
}, Symbol.toStringTag, { value: "Module" }));
const componentProps = {
  definition: {
    required: true,
    type: Object
  },
  disable: {
    default: false,
    type: Boolean
  },
  modelValue: {
    default: void 0,
    type: [Number, Object, String, Boolean]
  },
  /**
   * Daemon parameter requires project to be known.
   *
   * If it is not provided, the daemon parameter loads the project
   * based on the projectName route parameter.
   */
  project: {
    default: void 0,
    type: Object
  },
  readonly: {
    default: false,
    type: Boolean
  },
  valueOnly: {
    default: false,
    type: Boolean
  }
};
const newMessages = {
  "rvai-params": {
    errors: {
      bothAreRequired: "Both key and value are required",
      duplicatedKeys: "Keys should be unique",
      selectionRequired: "This field requires at least one selection"
    },
    general: {
      allSelected: "All selected",
      key: "key",
      no: "No",
      none: "None",
      text: {
        advancedParams: "Advanced parameters"
      },
      symbols: {
        colon: ":"
      },
      unset: "Unset",
      value: "value",
      yes: "Yes"
    }
  }
};
function initializeI18n() {
  const i18n = useI18n();
  i18n.mergeLocaleMessage("en", newMessages);
}
function initialize(options) {
  initializeI18n();
  provideOptions(options);
}
const PREFIX = "Rv";
const install = function(app) {
  Object.entries(components).forEach(([name, component]) => {
    app.component(`${PREFIX}${name}`, component);
  });
};
const plugin = { install };
export {
  ParamTitle,
  _sfc_main$1 as Parameter,
  ParameterList,
  ReadOnlyParam,
  componentProps,
  plugin as default,
  initialize,
  provideOptions,
  useOptions
};
//# sourceMappingURL=index.es.js.map
